export default "__VITE_ASSET__c682e170__"